import { writable } from 'svelte/store';

// Initialize with defaults - Header component will set correct values immediately
export const headerVisible = writable<boolean>(true);
export const isLandingPage = writable<boolean>(false);
